import React, { lazy } from 'react';
import { Navigate } from 'react-router-dom';

/* ***Layouts**** */
const FullLayout = lazy(() => import('../layouts/full-layout/FullLayout'));
const BlankLayout = lazy(() => import('../layouts/blank-layout/BlankLayout'));
/* ***End Layouts**** */

const Error = lazy(() => import('../views/authentication/Error'));
/* ****Pages***** */
const ClassroomEdit = lazy(() => import('../views/dashboard/Classroom/ClassroomEdit'));
const ClassroomLists = lazy(() => import('../views/dashboard/Classroom/ClassroomLists'));


const UserEdit = lazy(() => import('../views/dashboard/User/UserEdit'));
const UserLists = lazy(() => import('../views/dashboard/User/UserLists'));

const BookmanagementEdit = lazy(() => import('../views/dashboard/Bookmanagement/BookmanagementEdit'));
const BookmanagementLists = lazy(() => import('../views/dashboard/Bookmanagement/BookmanagementLists'));

const Boardcategorylists = lazy(() => import('../views/dashboard/Boardcaterogy/Boardcategorylists'));



const Makeuser = lazy(() => import('../views/dashboard/Makeuser/Makeuser'));
const Makeclass = lazy(() => import('../views/dashboard/Makeclass/Makeclass'));

const Sendmessage = lazy(() => import('../views/dashboard/Sendmessage/Sendmessage'));
const Sendhomowork = lazy(() => import('../views/dashboard/Sendhomowork/Sendhomowork'));

/* ****Routes***** */

const Router = [
  {
    path: '/',
    element: <FullLayout />,
    children: [
      { path: '/', element: <Navigate to="/UserLists" /> },
      { path: '/ClassroomLists', exact: true, element: <ClassroomLists /> },
      { path: '/ClassroomEdit', exact: true, element: <ClassroomEdit /> },
      { path: '/UserLists', exact: true, element: <UserLists /> },
      { path: '/UserEdit', exact: true, element: <UserEdit /> },
      { path: '/BookmanagementLists', exact: true, element: <BookmanagementLists /> },
      { path: '/BookmanagementEdit', exact: true, element: <BookmanagementEdit /> },     
      { path: '/Boardcategorylists', exact: true, element: <Boardcategorylists /> },    
      { path: '/Makeuser', exact: true, element: <Makeuser /> },
      { path: '/Makeclass', exact: true, element: <Makeclass /> },
      { path: '/Sendmessage', exact: true, element: <Sendmessage /> },
      { path: '/Sendhomowork', exact: true, element: <Sendhomowork /> },
      
      { path: '*', element: <Navigate to="/auth/404" /> },
    ],
  },
  {
    path: '/auth',
    element: <BlankLayout />,
    children: [
      { path: '404', element: <Error /> },
      { path: '*', element: <Navigate to="/auth/404" /> },
    ],
  },
];

export default Router;
